// Depends
import { route, meta } from '@/helpers/routes'
import Term from './term/index'
import Policy from './policy/index'

export default [
  route('/term', '/term', Term, meta('Termo de uso', false, 'guest', true)),
  route('/policy', '/policy', Policy, meta('Termo de uso', false, 'guest', true))
]



// WEBPACK FOOTER //
// ./src/app/auth/terms/routes.js